import { trackFb } from './fbpixel'

/**
 * Punto único de configuración comercial de la landing.
 */
export const CHECKOUT_URL = 'https://nos-mienten.impultienda.ar/checkout'

export const PRICE_USD = 'USD 9,99'

const PRODUCT = {
  content_name: 'NOS MIENTEN',
  content_type: 'product',
  currency: 'USD',
  value: 9.99,
}

export function openCheckout() {
  trackFb('InitiateCheckout', PRODUCT)
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
}

export function scrollToId(id: string) {
  if (id === 'oferta') {
    trackFb('AddToCart', PRODUCT)
  }
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
  })
}
